export default __webpack_public_path__ + "static/media/ic-applynow.729a5a00.svg";